import { getSubdomain } from '../../../../../packages/kiti/utils/helpers/url'

export const onInstallService = (config, keepOrigin, integration) => {
  const workspace = getSubdomain()
  let state = { workspace }
  if (integration) state = { ...state, integrationId: integration.id }
  if (keepOrigin)
    state = { ...state, origin: encodeURIComponent(`${window.location.pathname}${window.location.search}`) }

  const query = new URLSearchParams({
    response_type: 'code',
    client_id: config.CLIENT_ID,
    scope: config.SCOPE?.join(' '),
    state: JSON.stringify(state),
    redirect_uri: `${config.REDIRECT_URI}/${workspace}`,
    include_granted_scopes: true,
    access_type: 'offline',
    prompt: `select_account`
  }).toString()

  return window.open(`https://accounts.google.com/o/oauth2/v2/auth?${query}`)
}

export const useOnReinstall = (config, origin) => {
  return integration => onInstallService(config, integration)
}
